import { Outlet, useMatches } from "@tanstack/react-router";
import { Files } from "./Files";
import { FilesProvider } from "./FilesContext";

export const FilesWithProvider = () => {
  const matches = useMatches();
  const isFileDetailRoute = matches.some((m) => m.routeId.includes("/$fileId"));

  return (
    <FilesProvider>{isFileDetailRoute ? <Outlet /> : <Files />}</FilesProvider>
  );
};
